import React from 'react'
import Modal from '../../../components/Modal'
import DateRangeFilter from '../../../components/DateRangeFilter'
import ImportWizard from '../../../components/ImportWizard/ImportWizard'

export default function ExportImportModals({
  isAdmin,
  isExportModalOpen,
  setIsExportModalOpen,
  exportFormat,
  setExportFormat,
  exportStartDate,
  setExportStartDate,
  exportEndDate,
  setExportEndDate,
  exportColumns,
  setExportColumns,
  exporting,
  handleExport,
  showImport,
  setShowImport,
  employees,
  loadRecords,
  showImportHistory,
  setShowImportHistory,
  importHistory,
  deletingBatch,
  handleRollbackImport
}) {
  return (
    <>
      <Modal isOpen={isExportModalOpen} onClose={() => setIsExportModalOpen(false)} title="Настройка выгрузки" isBottomSheet={true}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '10px 0 24px 0' }}>
          <div className="input-group">
            <label>Формат файла</label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="button" className={`btn ${exportFormat === 'xls' ? 'btn-primary' : 'btn-ghost'}`} style={{ flex: 1 }} onClick={() => setExportFormat('xls')}>Excel (.xlsx)</button>
              <button type="button" className={`btn ${exportFormat === 'csv' ? 'btn-primary' : 'btn-ghost'}`} style={{ flex: 1 }} onClick={() => setExportFormat('csv')}>CSV (.csv)</button>
            </div>
          </div>

          <div className="input-group">
            <label>Период</label>
            <DateRangeFilter 
              startDate={exportStartDate} 
              endDate={exportEndDate}
              onApply={(s, e) => { setExportStartDate(s); setExportEndDate(e) }}
              onReset={() => { setExportStartDate(exportStartDate); setExportEndDate(exportEndDate) }} // Fallback or reuse dates
            />
          </div>

          <div className="input-group">
            <label>Какие столбцы выгрузить?</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', background: 'var(--bg-primary)', padding: '12px', borderRadius: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.date} onChange={e => setExportColumns({...exportColumns, date: e.target.checked})} /> Дата
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.time} onChange={e => setExportColumns({...exportColumns, time: e.target.checked})} /> Время
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.employee} onChange={e => setExportColumns({...exportColumns, employee: e.target.checked})} /> Сотрудник
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.type} onChange={e => setExportColumns({...exportColumns, type: e.target.checked})} /> Тип
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.value} onChange={e => setExportColumns({...exportColumns, value: e.target.checked})} /> Кол-во/Сумма
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.late} onChange={e => setExportColumns({...exportColumns, late: e.target.checked})} /> Опоздание
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.box} onChange={e => setExportColumns({...exportColumns, box: e.target.checked})} /> Коробка
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                <input type="checkbox" checked={exportColumns.returns_time} onChange={e => setExportColumns({...exportColumns, returns_time: e.target.checked})} /> Время возврата
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', gridColumn: 'span 2' }}>
                <input type="checkbox" checked={exportColumns.comment} onChange={e => setExportColumns({...exportColumns, comment: e.target.checked})} /> Комментарий
              </label>
            </div>
          </div>

          <button type="button" className="btn btn-primary" style={{ width: '100%', padding: '14px', marginTop: '10px' }} onClick={handleExport} disabled={exporting}>
            {exporting ? 'Генерация...' : `Выгрузить в ${exportFormat.toUpperCase()}`}
          </button>
          <button type="button" className="btn btn-ghost" style={{ width: '100%' }} onClick={() => setIsExportModalOpen(false)}>
            Отмена
          </button>
        </div>
      </Modal>

      {/* Модалка импорта */}
      {isAdmin && (
        <ImportWizard 
          isOpen={showImport} 
          onClose={() => setShowImport(false)} 
          employees={employees} 
          targetTable="work_logs"
          fields={[
            { id: 'date', label: 'Дата (рабочий день)', required: true },
            { id: 'employee', label: 'Сотрудник (ФИО)', required: true },
            { id: 'acceptance_col', label: 'Принято (шт)', required: false },
            { id: 'issued_col', label: 'Выдано (шт)', required: false },
            { id: 'returns_col', label: 'Возврат (шт)', required: false },
            { id: 'fines_col', label: 'Ручные штрафы (₽)', required: false },
            { id: 'comment', label: 'Комментарий', required: false }
          ]}
          onComplete={async () => {
            await loadRecords()
          }} 
        />
      )}

      {/* Модалка истории импортов */}
      <Modal isOpen={showImportHistory} onClose={() => setShowImportHistory(false)} title="История импортов (Операции)" isBottomSheet={true}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '10px 0 24px 0' }}>
          <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>Здесь вы можете отменить ошибочные загрузки операций.</p>
          <div className="import-history-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {importHistory.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-secondary)' }}>История пуста</div>
            ) : (
              importHistory.map(item => (
                <div key={item.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: 'var(--bg-primary)', borderRadius: '12px' }}>
                  <div>
                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>Пакет {item.id}</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Загружен: {new Date(item.date).toLocaleString()}</div>
                  </div>
                  <button 
                    type="button"
                    className="btn btn-ghost btn-sm" 
                    style={{ color: 'var(--danger)', background: 'var(--danger-bg)' }}
                    onClick={() => handleRollbackImport(item.id)}
                    disabled={deletingBatch === item.id}
                  >
                    {deletingBatch === item.id ? 'Удаление...' : 'Отменить импорт'}
                  </button>
                </div>
              ))
            )}
          </div>
          <button type="button" className="btn btn-primary" style={{ marginTop: '10px' }} onClick={() => setShowImportHistory(false)}>Закрыть</button>
        </div>
      </Modal>
    </>
  )
}
